import React, { useState, useEffect } from "react";

const PostContent = ({ content, media, isExpanded, onToggleExpand }) => {
  const MAX_CONTENT_LENGTH = 200;
  const showMore = content.length > MAX_CONTENT_LENGTH && !isExpanded;

  const [imageModalData, setImageModalData] = useState(null);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
    useEffect(() => {
      if (!imageModalData) return;
      const handleKeyDown = (e) => {
        switch (e.key) {
          case "ArrowLeft":
            prevImage();
            break;
          case "ArrowRight":
            nextImage();
            break;
          case "Escape":
            closeImageModal();
            break;
          default:
            break;
        }
      };
  
      window.addEventListener("keydown", handleKeyDown);
      return () => {
        window.removeEventListener("keydown", handleKeyDown);
      };
    }, [imageModalData, currentImageIndex]);
  const openImageModal = (files, index = 0) => {
    console.log(files);
    setImageModalData(files);
    setCurrentImageIndex(index);
  };

  const closeImageModal = () => {
    setImageModalData(null);
    setCurrentImageIndex(0);
  };

  const nextImage = () => {
    setCurrentImageIndex((prev) => (prev + 1) % imageModalData.length);
  };

  const prevImage = () => {
    setCurrentImageIndex(
      (prev) => (prev - 1 + imageModalData.length) % imageModalData.length
    );
  };

  return (
    <div className="px-4 pb-3">
      <div className="pb-2">
        <p className="whitespace-pre-line break-words text-base leading-relaxed">
          {showMore
            ? `${content.substring(0, MAX_CONTENT_LENGTH)}...`
            : content}
          {showMore && (
            <button
              onClick={onToggleExpand}
              className="text-blue-600 font-medium ml-1 hover:underline focus:outline-none"
            >
              See more
            </button>
          )}
        </p>
      </div>

      {media && media.length > 0 && (
        <div className="mt-3">
          {media.length === 1 ? (
            <div
              className="relative rounded-lg overflow-hidden bg-gray-100 flex justify-center"
              onClick={() => {
                openImageModal(post.media, index);
              }}
            >
              <img
                src={media[0].url}
                alt="Post media"
                className="w-full max-h-[500px] object-contain cursor-pointer"
              />
              {media[0].type === "video" && (
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-16 h-16 bg-black bg-opacity-50 rounded-full flex items-center justify-center">
                    <i className="fas fa-play text-white text-2xl"></i>
                  </div>
                </div>
              )}
            </div>
          ) : (
            <div
              className={`grid gap-1 overflow-hidden ${
                media.length === 2
                  ? "grid-cols-2"
                  : media.length === 3
                  ? "grid-cols-2"
                  : "grid-cols-2"
              }`}
              
            >
              {media.slice(0, 4).map((mediaItem, index) => (
                <div
                  key={mediaItem.id}
                  className={`relative group cursor-pointer flex justify-center ${
                    media.length === 3 && index === 2 ? "col-span-2" : ""
                  }`}
                  onClick={() => {
                    openImageModal(media, index);
                  }}
                >
                  <img
                    src={mediaItem.url}
                    alt="Post media"
                    className="w-full h-full object-cover bg-gray-100"
                  />
                  {index === 3 && media.length > 4 && (
                    <div className="absolute inset-0 flex items-center justify-center bg-black/40 text-white font-bold text-2xl">
                      <span className="text-white text-2xl font-bold">
                        +{media.length - 4}
                      </span>
                    </div>
                  )}
                </div>
              ))}
            </div>
          )}
        </div>
      )}
      {imageModalData && (
        <div
          className="fixed inset-0 bg-black bg-opacity-60 backdrop-blur-sm flex items-center justify-center z-50 animate-fade-in"
          tabIndex={-1}
        >
          <div className="relative bg-white rounded-xl shadow-2xl overflow-hidden w-[1000px] flex flex-col transition-all duration-300">
            <div className="w-full flex justify-end p-4 border-b border-gray-200 bg-white z-10">
              <button
                onClick={closeImageModal}
                className="bg-white hover:bg-gray-100 text-black rounded-full w-10 h-10 flex items-center justify-center shadow-md transition-transform duration-200 hover:scale-110"
                title="Close"
              >
                <i className="fas fa-times text-xl"></i>
              </button>
            </div>

            <div className="relative w-full h-[600px] bg-black flex items-center justify-center">
              {imageModalData[currentImageIndex].type === "image" ? (
                <img
                  src={imageModalData[currentImageIndex].url}
                  alt={imageModalData[currentImageIndex].name}
                  className="w-full h-full object-contain"
                />
              ) : (
                <video
                  src={imageModalData[currentImageIndex].url}
                  controls
                  className="w-full h-full object-contain"
                />
              )}
              {imageModalData.length > 1 && (
                <>
                  <button
                    onClick={prevImage}
                    className="absolute left-4 top-1/2 transform -translate-y-1/2 bg-white hover:bg-gray-100 text-black rounded-full w-10 h-10 flex items-center justify-center shadow-md transition-transform duration-200 hover:scale-110"
                    title="Previous"
                  >
                    <i className="fas fa-chevron-left text-xl"></i>
                  </button>
                  <button
                    onClick={nextImage}
                    className="absolute right-4 top-1/2 transform -translate-y-1/2 bg-white hover:bg-gray-100 text-black rounded-full w-10 h-10 flex items-center justify-center shadow-md transition-transform duration-200 hover:scale-110"
                    title="Next"
                  >
                    <i className="fas fa-chevron-right text-xl"></i>
                  </button>
                  <div className="absolute bottom-3 left-1/2 transform -translate-x-1/2 bg-white px-3 py-1 rounded-full shadow text-sm text-gray-700">
                    {currentImageIndex + 1} / {imageModalData.length}
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default PostContent;
